import React from 'react'

import APIFailureImage from '../../assets/images/HiFive/APIFailureImage'

const ApiFailurePage = ({ onTryAgain = () => { }, onBackClick = () => { } }) => {
  return (

    <React.Fragment>
      <div className="ta-c centered flex-column bg-white m-auto" style={{ width: '432px', height: '438px' }}>
        <APIFailureImage />

        <div className="color-neutral-900 fw-700 fs-24 lh-24 mb-1 pb-1">Oops! Something went wrong</div>
        <p className="color-neutral-700 fw-400 fs-16 lh-24 mb-8 pt-1">Please try again in sometime</p>

      </div>
    </React.Fragment>
  )
}

export default ApiFailurePage
